var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChrome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 55 55",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.0042577 C0,1.79276724 1.79201988,0 3.99116665,0 L95,0 L95,32 L3.99116665,32 C1.78690618,32 0,30.2109725 0,27.9957423 L0,4.0042577 Z",
    id: "chrommmeeee1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "chrommmeeee",
    x: 0,
    y: 0,
    width: 1180,
    height: 920
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,5.9966931 C450,2.68481095 447.314733,0 443.999917,0 L6.00008331,0 C2.6863288,0 0,2.69013683 0,5.9966931 L0,89.0033069 C0,92.3151891 2.68526677,95 6.00008331,95 L443.999917,95 C447.313671,95 450,92.3098632 450,89.0033069 L450,5.9966931 Z",
    id: "chrommmeeee4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.4%",
    y: "-15.3%",
    width: "106.9%",
    height: "132.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "chrommmeeee6",
    cx: 27.5,
    cy: 27.5,
    r: 27.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.54854039%",
    y1: "55.4170778%",
    x2: "36.9499475%",
    y2: "42.6565727%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0,
    offset: "66%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.8129129%",
    y1: "87.7758275%",
    x2: "42.0009683%",
    y2: "66.3365095%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0,
    offset: "33%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "chrommmeeee10",
    points: "0 50 26.030226 50 38.1115819 37.85 38.1115819 28.75 16.5776836 28.75 0 0.15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.1029975%",
    y1: "-4.84375%",
    x2: "49.284789%",
    y2: "45.390625%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0,
    offset: "66%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-4.84693878%",
    cy: "-0.238663484%",
    fx: "-4.84693878%",
    fy: "-0.238663484%",
    r: "399.069078%",
    gradientTransform: "translate(-0.048469,-0.002387),scale(0.268738,1.000000),translate(0.048469,0.002387)",
    id: "radialGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "chrommmeeee14",
    points: "0.301412429 0 0.301412429 12.60625 12.5412429 33.75 23.3050847 15 50.6497175 15 50.6497175 0"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-0.122270742%",
    cy: "0.103626943%",
    fx: "-0.122270742%",
    fy: "0.103626943%",
    r: "136.31441%",
    gradientTransform: "translate(-0.001223,0.001036),scale(1.000000,0.842732),translate(0.001223,-0.001036)",
    id: "radialGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "10.2266873%",
    cy: "-12.2250639%",
    fx: "10.2266873%",
    fy: "-12.2250639%",
    r: "226.352396%",
    gradientTransform: "translate(0.102267,-0.122251),scale(1.000000,0.493615),translate(-0.102267,0.122251)",
    id: "radialGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chrome1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrome2",
    transform: "translate(-990.000000, -80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrome6",
    transform: "translate(1010.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrome5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#chrommmeeee1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1890FF",
    strokeWidth: 1,
    d: "M94.5,0.5 L94.5,31.5 L3.99116665,31.5 C3.02687242,31.5 2.15392372,31.1084841 1.52220234,30.4746906 C0.89043719,29.8408533 0.5,28.9648165 0.5,27.9957423 L0.5,27.9957423 L0.5,4.0042577 C0.5,3.03697878 0.891682991,2.1612229 1.5237761,1.52705652 C2.15603049,0.892728328 3.02895114,0.5 3.99116665,0.5 L3.99116665,0.5 L94.5,0.5 Z",
    strokeLinejoin: "square",
    fillOpacity: 0.05,
    fill: "#1890FF"
  })), /*#__PURE__*/React.createElement("text", {
    id: "chrome4",
    fontFamily: "AvenirNext-DemiBold, Avenir Next",
    fontSize: 12,
    fontWeight: 500,
    "line-spacing": 22,
    fill: "#1890FF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31.222,
    y: 17
  }, "Leads"))), /*#__PURE__*/React.createElement("g", {
    id: "chrome3",
    transform: "translate(260.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "chrome7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrommmeeee"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#DFE2E5",
    x: -0.5,
    y: -0.5,
    width: 1181,
    height: 921
  }), /*#__PURE__*/React.createElement("g", {
    id: "chrome3-header",
    mask: "url(#chrome7)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "chrome8",
    x: 0,
    y: 0,
    width: 1180,
    height: 94
  }))), /*#__PURE__*/React.createElement("g", {
    id: "menu-copy",
    transform: "translate(970.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrome9"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#chrommmeeee4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#chrommmeeee4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chrome12-13",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "chrome11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrommmeeee6"
  })), /*#__PURE__*/React.createElement("use", {
    id: "chrome9",
    fill: "#F1F1F1",
    fillRule: "nonzero",
    xlinkHref: "#chrommmeeee6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chrome12-10",
    mask: "url(#chrome11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chrome12-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fill: "#DB4437",
    fillRule: "nonzero",
    points: "4.34096045 -2.68673972e-14 4.34096045 33.75 16.5838983 33.75 27.3446328 15 54.6892655 15 54.6892655 -2.68673972e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fill: "url(#linearGradient-8)",
    fillRule: "nonzero",
    points: "4.34096045 -2.68673972e-14 4.34096045 33.75 16.5838983 33.75 27.3446328 15 54.6892655 15 54.6892655 -2.68673972e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fillOpacity: 0.15,
    fill: "#3E2723",
    fillRule: "nonzero",
    points: "16.8728814 33.625 4.49943503 12.28125 4.31920904 12.59375 16.6056497 33.78125"
  }), /*#__PURE__*/React.createElement("g", {
    id: "B-link",
    transform: "translate(-0.000000, 5.000000)",
    fill: "#0F9D58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "B",
    points: "0 50 26.030226 50 38.1115819 37.85 38.1115819 28.75 16.5776836 28.75 0 0.15"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero",
    points: "-2.19824159e-14 55 26.030226 55 38.1115819 42.85 38.1115819 33.75 16.5776836 33.75 -2.19824159e-14 5.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fillOpacity: 0.15,
    fill: "#263238",
    fillRule: "nonzero",
    points: "37.8474576 34.15625 37.589548 34.00625 25.6573446 54.990625 26.0146893 54.990625 37.8536723 34.165625"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chrome13",
    transform: "translate(-0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrommmeeee10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chrome12",
    mask: "url(#mask-11)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.790960, 10.000000)",
    id: "chrome14"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCD40",
    points: "1.55367232 0 12.3206215 18.75 0.239265537 40 28.8983051 40 28.8983051 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#linearGradient-12)",
    points: "1.55367232 0 12.3206215 18.75 0.239265537 40 28.8983051 40 28.8983051 0"
  })))), /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fill: "#FFCD40",
    fillRule: "nonzero",
    points: "27.3446328 15 38.1115819 33.75 26.030226 55 54.6892655 55 54.6892655 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero",
    points: "27.3446328 15 38.1115819 33.75 26.030226 55 54.6892655 55 54.6892655 15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chrome12",
    transform: "translate(4.039548, -0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fill: "url(#radialGradient-13)",
    fillRule: "nonzero",
    points: "23.3050847 15 23.3050847 21.546875 47.6666667 15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chrome13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrommmeeee14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chrome12",
    mask: "url(#mask-15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.039548, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-link",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "B",
    fill: "#0F9D58",
    fillRule: "nonzero",
    points: "0 50 26.030226 50 38.1115819 37.85 38.1115819 28.75 16.5776836 28.75 0 0.15"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero",
    points: "0 50 26.030226 50 38.1115819 37.85 38.1115819 28.75 16.5776836 28.75 0 0.15"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fill: "url(#radialGradient-16)",
    fillRule: "nonzero",
    points: "4.34096045 12.640625 22.1305085 30.528125 16.580791 33.75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chrome12",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "chrome14",
    fill: "url(#radialGradient-17)",
    points: "26.0488701 54.96875 32.5618644 30.53125 38.1115819 33.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F1F1F1",
    cx: 27.3446328,
    cy: 27.5,
    rx: 12.4293785,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#4285F4",
    cx: 27.3446328,
    cy: 27.5,
    rx: 9.94350282,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3446328,14.6875 C20.4774011,14.6875 14.9152542,20.28125 14.9152542,27.1875 L14.9152542,27.5 C14.9152542,20.59375 20.4774011,15 27.3446328,15 L54.6892655,15 L54.6892655,14.6875 L27.3446328,14.6875 Z",
    id: "chrome14",
    fillOpacity: 0.2,
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0960452,33.75 C35.9457627,37.48125 31.9435028,40 27.3446328,40 C22.7457627,40 18.7372881,37.48125 16.5932203,33.75 L16.580791,33.75 L0,5.15 L0,5.4625 L16.5932203,34.0625 C18.7435028,37.79375 22.7457627,40.3125 27.3446328,40.3125 C31.9435028,40.3125 35.9457627,37.796875 38.0960452,34.0625 L38.1115819,34.0625 L38.1115819,33.75 L38.0929379,33.75 L38.0960452,33.75 Z",
    id: "chrome14",
    fillOpacity: 0.1,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6553672,15 C27.6025424,15 27.5528249,15.00625 27.5,15.009375 C34.2926554,15.09375 39.7740113,20.65 39.7740113,27.5 C39.7740113,34.35 34.2926554,39.90625 27.5,39.990625 C27.5528249,39.990625 27.6025424,40 27.6553672,40 C34.5225989,40 40.0847458,34.40625 40.0847458,27.5 C40.0847458,20.59375 34.5225989,15 27.6553672,15 Z",
    id: "chrome14",
    fill: "#3E2723",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.220339,34.15625 C39.2768362,32.31875 39.8889851,30.19375 39.8889851,27.91875 C39.8897119,26.6368113 39.693714,25.3624377 39.3079096,24.140625 C39.6031073,25.209375 39.7740113,26.328125 39.7740113,27.49375 C39.7740113,29.76875 39.1618644,31.89375 38.1053672,33.73125 L38.1115819,33.74375 L26.030226,54.99375 L26.390678,54.99375 L38.220339,34.15625 Z",
    id: "chrome14",
    fillOpacity: 0.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3446328,0.3125 C42.3935028,0.3125 54.6022599,12.540625 54.6892655,27.65625 C54.6892655,27.603125 54.6923729,27.553125 54.6923729,27.5 C54.6923729,12.3125 42.449435,0 27.3477401,0 C12.2460452,0 0,12.3125 0,27.5 C0,27.553125 0.00310734463,27.603125 0.00310734463,27.65625 C0.0870056497,12.540625 12.2957627,0.3125 27.3446328,0.3125 Z",
    id: "chrome14",
    fillOpacity: 0.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3446328,54.6875 C42.3935028,54.6875 54.6022599,42.459375 54.6892655,27.34375 C54.6892655,27.396875 54.6923729,27.446875 54.6923729,27.5 C54.6923729,42.6875 42.449435,55 27.3477401,55 C12.2460452,55 0,42.6875 0,27.5 C0,27.446875 0.00310734463,27.396875 0.00310734463,27.34375 C0.0870056497,42.459375 12.2957627,54.6875 27.3477401,54.6875 L27.3446328,54.6875 Z",
    id: "chrome14",
    fillOpacity: 0.15,
    fill: "#3E2723"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChrome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chrome.6bd1f5e5.svg";
export { ForwardRef as ReactComponent };